var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#a3a3a3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-883 -171)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12,
    height: 12,
    transform: "translate(883 171)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(885 173)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.375,4.421,8.669,1.127a.483.483,0,0,0,0-.681L8.381.157a.483.483,0,0,0-.682,0L4.405,3.451,1.111.157a.483.483,0,0,0-.681,0L.141.445a.482.482,0,0,0,0,.681L3.435,4.421.141,7.715a.483.483,0,0,0,0,.682l.289.289a.483.483,0,0,0,.681,0L4.405,5.391,7.7,8.685a.478.478,0,0,0,.341.141h0a.478.478,0,0,0,.341-.141L8.669,8.4a.483.483,0,0,0,0-.681Z",
    transform: "translate(0 -0.016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseX);
export default __webpack_public_path__ + "static/media/close-x.50b4761a071240fe21b65d6febaa06b4.svg";
export { ForwardRef as ReactComponent };